export const statuses = {
    LO: 'LO'
};